<printheaderview [hasimage]="1"></printheaderview>
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-11 text-align-center">
            <label class="margin-bottom-10px font-familyhead">PATIENT DISCHARGE SUMMARY</label>
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px">
            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient Name:</label>
                </div>
                <div class="col-print-8">
                  <!--<label class="margin-bottom-0px font-family float-left font-weight-bold">{{l.PatientName}}</label>-->
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                </div>
                <div class="col-print-8">
                  <!--<label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.PatientCode}}</label>-->
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Referred By:</label>
                </div>
                <div class="col-print-8">
                  <!--<label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.ReferenceNo}}</label>-->
                </div>
              </div>
            </div>

            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Bill Date:</label>
                </div>
                <div class="col-print-8">
                  <!--<label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.ReceiptDate | date:'dd-MMM-yyyy'}}</label>-->
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Bill No:</label>
                </div>
                <div class="col-print-8">
                  <!--<label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.BillNo}}</label>-->
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
                </div>
                <div class="col-print-8">
                  <!--<label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Branch}}</label>-->
                </div>
              </div>

            </div>
          </div>
        </div>


        <div class="col-print-12">
          <div class="row margin-left-0px">

            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead">Admission Details</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Admission ID:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Admission Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Ward / Room:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Treating Doctor:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Admission Reason:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
            </div>

            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead">Discharge Details</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Discharge Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Approved By:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">TPA / Card No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>


            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family font-weight-bold">Diagnosis</label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Lab investigations ordered and a scan code done.</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family font-weight-bold">Presenting Complaints</label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">
                The patient complains of recurrent pain in the chest.
                (1) Suspected Gastric Case. (2) Cardiac Problem
                expected. The patient also complained of loss of sleep
                and hallucinations. Also has high fever
              </label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family font-weight-bold">Details Of Procedure</label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-8">
          <div class="row margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero width-50-new">
                    <tr>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Date
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        20-11-2019
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        21-11-2019
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        22-11-2019
                      </th>

                    </tr>
                    <tr>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">Procedure</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">Diag.Hysteris</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">IUI</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">IUF with ICSI</td>

                    </tr>
                    <tr>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">Remarks</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">Diag.Hysteris</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">IUI</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">IUF with ICSI</td>

                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family font-weight-bold"></label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family font-weight-bold">Summary Of Course In Hospitals</label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">
                The patient was first advised for Hysteroscopy. The DH
                was done under IV sedation. There were lesions
                observed which were removed without much
                difficulty. The patient was then advised for IUI and
                there were 2 attempts made. The IUI was also
                unsuccessful and the patient could not conceive this
                time also. Next we did was IVF. The IVF first cycle was
                also unsuccessful.
              </label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family font-weight-bold">Condition On Discharge</label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">Patient is stable and doing well.</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family font-weight-bold">Advice</label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">
                Med. 1, Med. 2. Med 3 twice in the day. Med 4 to be
                taken 4 times a week at an interval of a day, before
                food in the night.
              </label>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<plainfooterview></plainfooterview>


